import {abilitiesPlugin} from '@casl/vue'
import ability from "./core/plugins/ability";
import EventHub from "./core/plugins/EventHubPlugin/EventHub";
import BackButton from './view/pages/plugins/BackButton';
import ImageUpload from './view/pages/plugins/imageUpload';
import Loading from "@/view/content/modals/Loading";
import Content from "@/view/content/modals/Content";
import priceInput from "@/view/pages/pickers/priceInput.vue";
import acl from './core/plugins/acl'

const GlobalComponents = {
    install(Vue) {
        // Vue.use(abilitiesPlugin, ability)
        Vue.use(EventHub)
        Vue.component('back-button', BackButton)
        Vue.component('price-input',priceInput)
        Vue.component('image-upload', ImageUpload)
        Vue.component('loading', Loading)
        Vue.component('content-text', Content)
        Vue.use(acl)
    }
}

export default GlobalComponents
